// Product archive (shop/category) — mobile filters overlay.
(() => {
  const root = document.querySelector(".c-product-archive");
  if (!root) return;

  const openBtn = root.querySelector("[data-archive-filters-open]");
  const closeBtn = root.querySelector("[data-archive-filters-close]");
  const overlay = root.querySelector(".c-product-archive__filters-overlay");
  const forms = root.querySelectorAll("[data-archive-filters-form]");
  const productsList = root.querySelector(".c-product-archive__listing .products");
  const infinite = root.querySelector(".c-product-archive__infinite");
  const sentinel = root.querySelector("[data-archive-sentinel]");
  const spinner = root.querySelector("[data-archive-spinner]");
  const statusEl = root.querySelector("[data-archive-status]");

  const ctxTax = root.getAttribute("data-archive-context-tax") || "";
  const ctxId = parseInt(root.getAttribute("data-archive-context-id") || "0", 10) || 0;
  const getMaxPages = () =>
    parseInt(root.getAttribute("data-archive-max-pages") || "1", 10) || 1;
  const setMaxPages = (n) =>
    root.setAttribute("data-archive-max-pages", String(Math.max(1, n || 1)));
  const getCurrentPage = () =>
    parseInt(root.getAttribute("data-archive-current-page") || "1", 10) || 1;
  const setCurrentPage = (n) =>
    root.setAttribute("data-archive-current-page", String(Math.max(1, n || 1)));

  if (!productsList) return;

  const ajax = window.labifyArchive || null;
  const canAjax = !!(ajax && ajax.ajaxurl);

  let isLoading = false;
  let io = null;

  const setHeaderOffsetVar = () => {
    // Mobile filters overlay should start below the site header.
    const isMobile = window.matchMedia && window.matchMedia("(max-width: 991px)").matches;
    if (!isMobile) {
      root.style.removeProperty("--archive-header-offset");
      return;
    }
    const header = document.querySelector(".header");
    const rect = header?.getBoundingClientRect?.();
    const h = rect ? rect.bottom : header?.offsetHeight || 0;
    root.style.setProperty("--archive-header-offset", `${h}px`);
  };

  const open = () => {
    setHeaderOffsetVar();
    root.classList.add("is-filters-open");
    document.body.classList.add("c-product-archive-filters-open");
    if (overlay) overlay.setAttribute("aria-hidden", "false");
    if (openBtn) openBtn.setAttribute("aria-expanded", "true");
  };

  const close = () => {
    root.classList.remove("is-filters-open");
    document.body.classList.remove("c-product-archive-filters-open");
    if (overlay) overlay.setAttribute("aria-hidden", "true");
    if (openBtn) openBtn.setAttribute("aria-expanded", "false");
  };

  if (openBtn) {
    openBtn.addEventListener("click", (e) => {
      e.preventDefault();
      open();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      close();
    });
  }

  if (overlay) {
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) close();
    });
  }

  window.addEventListener("resize", () => {
    if (root.classList.contains("is-filters-open")) setHeaderOffsetVar();
  });

  window.addEventListener(
    "scroll",
    () => {
      if (root.classList.contains("is-filters-open")) setHeaderOffsetVar();
    },
    { passive: true }
  );

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && root.classList.contains("is-filters-open")) {
      close();
    }
  });

  const showSpinner = () => {
    if (!spinner) return;
    spinner.hidden = false;
    spinner.removeAttribute("hidden");
    spinner.style.display = "block";
    spinner.classList.add("is-active");
    if (infinite) infinite.hidden = false;
  };
  const hideSpinner = () => {
    if (!spinner) return;
    spinner.hidden = true;
    spinner.setAttribute("hidden", "");
    spinner.style.display = "none";
    spinner.classList.remove("is-active");
    syncInfiniteVisibility();
  };
  const setStatus = (msg) => {
    if (!statusEl) return;
    const m = (msg || "").trim();
    statusEl.textContent = m;
    statusEl.hidden = m === "";
  };
  const clearStatus = () => setStatus("");

  const syncInfiniteVisibility = () => {
    if (!sentinel) return;
    const current = getCurrentPage();
    const max = getMaxPages();
    const hasMore = current < max;
    sentinel.hidden = !hasMore;
    if (infinite) {
      // Hide the entire infinite section when not loading and no more pages.
      infinite.hidden = !hasMore && !isLoading;
    }
  };

  // Liczniki filtrów (facety) z odpowiedzi AJAX.
  //
  // Serwer przysyła same liczby — markup opcji ZAWSZE jest w DOM (opcje bez
  // wyników dostają `hidden`/`is-disabled`, nie znikają), bo inaczej po
  // odznaczeniu filtra nie mielibyśmy czego przywrócić.
  const applyFacets = (facets) => {
    if (!facets || !facets.terms) return;
    const behavior = facets.behavior || "show";

    forms.forEach((form) => {
      form
        .querySelectorAll(".c-product-archive-filters__group")
        .forEach((group) => {
          const tax = group.getAttribute("data-tax") || "";
          const counts = facets.terms[tax] || {};
          let available = 0;

          group
            .querySelectorAll('input[type="checkbox"][name^="lf["]')
            .forEach((cb) => {
              const item = cb.closest(".c-product-archive-filters__item");
              if (!item) return;

              const n = parseInt(counts[cb.value] || 0, 10) || 0;
              // Zaznaczonej opcji nigdy nie chowamy ani nie blokujemy —
              // inaczej klient nie mógłby jej odznaczyć.
              const isEmpty = n === 0 && !cb.checked;
              if (!isEmpty) available += 1;

              if (facets.counts) {
                const badge = item.querySelector("[data-lf-count]");
                if (badge) badge.textContent = `(${n})`;
              }

              item.classList.toggle("is-disabled", isEmpty && behavior === "disable");
              item.hidden = isEmpty && behavior === "hide";
              cb.disabled = isEmpty && behavior !== "show";
            });

          group.hidden = !!facets.hideGroups && available === 0;
        });
    });
  };

  const buildParamsFromForm = (form) => {
    const fd = new FormData(form);
    const params = new URLSearchParams();
    fd.forEach((value, key) => {
      const v = typeof value === "string" ? value : String(value);
      if (v === "") return;
      params.append(key, v);
    });
    // Always reset paging on filter submit.
    params.delete("paged");
    return params;
  };

  const setQueryString = (params, { replace = false } = {}) => {
    const qs = params.toString();
    const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
    const method = replace ? "replaceState" : "pushState";
    window.history[method]({ labifyArchive: true }, "", url);
  };

  const getOrderSelects = () =>
    Array.from(root.querySelectorAll(".woocommerce-ordering select[name='orderby']"));
  const getVisibleOrderSelect = () =>
    getOrderSelects().find((el) => el && el.offsetParent !== null) || getOrderSelects()[0] || null;
  const syncOrderSelects = (value) => {
    getOrderSelects().forEach((sel) => {
      if (!sel) return;
      sel.value = value || "";
      // Keep custom UI in sync.
      if (typeof sel._labifyUpdateCustomOrderingUI === "function") {
        sel._labifyUpdateCustomOrderingUI();
      }
    });
  };

  const getOrderingValue = () => {
    const sel = getVisibleOrderSelect();
    return sel && sel.value ? sel.value : "";
  };

  const enhanceOrderingSelect = (sel) => {
    if (!sel) return;
    if (sel.dataset.customized === "1") return;

    const form = sel.closest(".woocommerce-ordering");
    if (!form) return;
    const host = form.parentElement;
    if (!host) return;

    // WooCommerce/legacy themes may rely on inline `onchange="this.form.submit()"` (or similar).
    // That path calls `form.submit()` directly and bypasses `submit` events, causing full reload.
    sel.removeAttribute("onchange");
    if (form.getAttribute("onchange")) form.removeAttribute("onchange");
    if (!form._labifyOrigSubmit) {
      form._labifyOrigSubmit = form.submit.bind(form);
      form.submit = () => {
        if (!canAjax) return form._labifyOrigSubmit();
      };
    }

    const dropdown = document.createElement("div");
    dropdown.className = "c-product-archive-sort__dropdown";

    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "c-product-archive-sort__trigger";
    trigger.setAttribute("aria-haspopup", "listbox");
    trigger.setAttribute("aria-expanded", "false");

    const valueEl = document.createElement("span");
    valueEl.className = "c-product-archive-sort__value";

    const chevron = document.createElement("span");
    chevron.className = "c-product-archive-sort__chevron";
    chevron.setAttribute("aria-hidden", "true");

    trigger.appendChild(valueEl);
    trigger.appendChild(chevron);

    const menu = document.createElement("ul");
    menu.className = "c-product-archive-sort__menu";
    menu.setAttribute("role", "listbox");
    menu.setAttribute("aria-hidden", "true");

    const updateUI = () => {
      const opt = sel.options[sel.selectedIndex];
      valueEl.textContent = opt ? opt.textContent : "";
      Array.from(menu.querySelectorAll("[role='option']")).forEach((li) => {
        const v = li.getAttribute("data-value") || "";
        li.setAttribute("aria-selected", v === sel.value ? "true" : "false");
      });
    };
    sel._labifyUpdateCustomOrderingUI = updateUI;

    const closeMenu = () => {
      trigger.setAttribute("aria-expanded", "false");
      menu.setAttribute("aria-hidden", "true");
    };

    const openMenu = () => {
      trigger.setAttribute("aria-expanded", "true");
      menu.setAttribute("aria-hidden", "false");
    };

    const toggleMenu = () => {
      const isOpen = menu.getAttribute("aria-hidden") === "false";
      if (isOpen) closeMenu();
      else openMenu();
    };

    const options = Array.from(sel.options || []);
    options.forEach((o) => {
      const li = document.createElement("li");
      li.setAttribute("role", "option");
      li.setAttribute("data-value", o.value);
      li.className = "c-product-archive-sort__option";
      li.setAttribute("aria-selected", o.value === sel.value ? "true" : "false");
      li.tabIndex = -1;
      li.textContent = o.textContent;
      li.addEventListener("click", () => {
        closeMenu();
        if (sel.value !== o.value) {
          sel.value = o.value;
          updateUI();
          // Trigger existing change handler (AJAX).
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
      menu.appendChild(li);
    });

    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      toggleMenu();
    });

    trigger.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeMenu();
        return;
      }
      if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openMenu();
        const current = menu.querySelector("[aria-selected='true']");
        const first = menu.querySelector("[role='option']");
        (current || first)?.focus?.();
      }
    });

    menu.addEventListener("keydown", (e) => {
      const items = Array.from(menu.querySelectorAll("[role='option']"));
      const currentIdx = items.indexOf(document.activeElement);
      if (e.key === "Escape") {
        e.preventDefault();
        closeMenu();
        trigger.focus();
        return;
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        const next = items[Math.min(items.length - 1, currentIdx + 1)];
        next?.focus?.();
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        const prev = items[Math.max(0, currentIdx - 1)];
        prev?.focus?.();
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        document.activeElement?.click?.();
      }
    });

    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target)) closeMenu();
    });

    // Hide native select UI, keep it for state.
    sel.classList.add("is-native-hidden");

    dropdown.appendChild(trigger);
    dropdown.appendChild(menu);

    // Place custom dropdown after ordering form.
    host.appendChild(dropdown);
    updateUI();

    sel.dataset.customized = "1";
  };

  const getSearchValue = (params) => {
    if (params.has("s")) return params.get("s") || "";
    const s = root.querySelector("input[name='s']");
    return s && s.value ? s.value : "";
  };

  const doFetch = async ({ paged, params, mode }) => {
    if (!canAjax) return null;
    if (isLoading) return null;
    isLoading = true;
    showSpinner();
    root.classList.add("is-loading");
    if (mode === "replace") clearStatus();

    // Nie zostawiaj użytkownika z wrażeniem, że „nic się nie dzieje" — przy
    // nieudanym żądaniu lista zostaje niezmieniona, więc trzeba to powiedzieć.
    const fail = () => {
      setStatus("Nie udało się wczytać produktów. Odśwież stronę i spróbuj ponownie.");
      return null;
    };

    try {
      const body = new URLSearchParams();
      body.set("action", "labify_archive_products");
      body.set("paged", String(paged));

      const orderby = params.get("orderby") || getOrderingValue();
      if (orderby) body.set("orderby", orderby);

      const s = getSearchValue(params);
      if (s) body.set("s", s);

      // Preserve post_type=product for search pages.
      if (params.get("post_type") === "product") body.set("post_type", "product");

      // Pass listing filters (lf[...][]).
      params.forEach((v, k) => {
        if (k.startsWith("lf[")) body.append(k, v);
      });

      // Context constraint.
      if (ctxTax) body.set("context_tax", ctxTax);
      if (ctxId) body.set("context_id", String(ctxId));

      const res = await fetch(ajax.ajaxurl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: body.toString(),
        credentials: "same-origin",
      });
      if (!res.ok) return fail();

      const json = await res.json().catch(() => null);
      if (!json || !json.success || !json.data) return fail();

      const html = json.data.html || "";
      const maxPages = parseInt(json.data.max_pages || "1", 10) || 1;
      setMaxPages(maxPages);
      setCurrentPage(paged);

      if (mode === "replace") {
        productsList.innerHTML = html;
        if (!html.trim()) {
          setStatus("Brak wyników.");
        }
      } else if (mode === "append") {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        // Append only element nodes produced by templates.
        Array.from(tmp.children).forEach((child) => {
          productsList.appendChild(child);
        });
      }

      if (json.data.facets) applyFacets(json.data.facets);

      // After replace/append, WooCommerce scripts (if any) may need events; keep minimal.
      document.dispatchEvent(new CustomEvent("labify:archive:updated", { detail: { mode } }));
      syncInfiniteVisibility();
      return { maxPages };
    } catch (e) {
      return fail();
    } finally {
      hideSpinner();
      isLoading = false;
      root.classList.remove("is-loading");
    }
  };

  const submitFormAjax = async (form, { replaceHistory = false } = {}) => {
    const params = buildParamsFromForm(form);
    setQueryString(params, { replace: replaceHistory });
    const out = await doFetch({ paged: 1, params, mode: "replace" });
    if (out) {
      // If filter panel open (mobile), close after applying.
      close();
    }
  };

  const syncFormValues = (params) => {
    // Keep both forms in sync with the URL (checkboxes + search + orderby).
    forms.forEach((form) => {
      // Text inputs.
      form.querySelectorAll("input[type='search'][name='s']").forEach((el) => {
        el.value = params.get("s") || "";
      });

      // Checkboxes.
      form
        .querySelectorAll("input[type='checkbox'][name^='lf[']")
        .forEach((cb) => {
          const name = cb.getAttribute("name");
          const val = cb.value;
          if (!name) return;
          const active = params.getAll(name).includes(val);
          cb.checked = active;
        });

      // Preserve hidden common fields (orderby, post_type).
      form.querySelectorAll("input[type='hidden']").forEach((h) => {
        const n = h.getAttribute("name");
        if (!n) return;
        if (params.has(n)) h.value = params.get(n) || "";
      });
    });

    if (params.has("orderby")) {
      syncOrderSelects(params.get("orderby") || "");
    }
  };

  const fetchFromLocation = async ({ replaceHistory = true } = {}) => {
    if (!canAjax) return;
    const params = new URLSearchParams(window.location.search);
    params.delete("paged");
    syncFormValues(params);
    await doFetch({ paged: 1, params, mode: "replace" });
    if (replaceHistory) setQueryString(params, { replace: true });
  };

  // Desktop UX: auto-submit filters on checkbox/search change.
  forms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      if (!canAjax) return;
      e.preventDefault();
      submitFormAjax(form);
    });

    const ctx = form.getAttribute("data-context");
    if (ctx !== "desktop") return;
    form.addEventListener("change", (e) => {
      if (!canAjax) return;
      const target = e.target;
      if (!target) return;
      if (
        target.matches('input[type="checkbox"]') ||
        target.matches('input[type="search"]')
      ) {
        requestAnimationFrame(() => submitFormAjax(form));
      }
    });
  });

  // Sorting (Woo) change => fetch + update URL (no reload).
  // WooCommerce may auto-submit `.woocommerce-ordering` on change; prevent full page reload.
  root.querySelectorAll("form.woocommerce-ordering").forEach((f) => {
    f.addEventListener("submit", (e) => {
      if (!canAjax) return;
      e.preventDefault();
    });
  });

  const handleOrderingChange = (orderSel) => {
    const params = new URLSearchParams(window.location.search);
    const next = orderSel.value || "";
    params.set("orderby", next);
    params.delete("paged");
    setQueryString(params);
    syncOrderSelects(next);
    // Also sync hidden orderby fields if present.
    forms.forEach((form) => {
      const h = form.querySelector("input[type='hidden'][name='orderby']");
      if (h) h.value = next;
    });
    doFetch({ paged: 1, params, mode: "replace" });
  };

  getOrderSelects().forEach((orderSel) => {
    if (!orderSel) return;
    enhanceOrderingSelect(orderSel);
    // Capture phase: stop other change listeners that may submit the form (page reload).
    orderSel.addEventListener(
      "change",
      (e) => {
        if (!canAjax) return;
        e.stopImmediatePropagation();
        handleOrderingChange(orderSel);
      },
      true
    );
  });

  // "Clear all" in mobile: intercept link and fetch.
  root.querySelectorAll(".c-product-archive-filters__clear").forEach((a) => {
    a.addEventListener("click", (e) => {
      if (!canAjax) return;
      e.preventDefault();
      const params = new URLSearchParams(window.location.search);
      // remove all lf[...] and paging
      Array.from(params.keys()).forEach((k) => {
        if (k.startsWith("lf[")) params.delete(k);
      });
      params.delete("s");
      params.delete("paged");
      setQueryString(params);
      fetchFromLocation({ replaceHistory: true });
    });
  });

  // Desktop "Clear all" near header.
  root.querySelectorAll(".c-product-archive-filters__clear-all").forEach((a) => {
    a.addEventListener("click", (e) => {
      if (!canAjax) return;
      e.preventDefault();
      const params = new URLSearchParams(window.location.search);
      Array.from(params.keys()).forEach((k) => {
        if (k.startsWith("lf[")) params.delete(k);
      });
      params.delete("s");
      params.delete("paged");
      setQueryString(params);
      fetchFromLocation({ replaceHistory: true });
    });
  });

  // Infinite scroll.
  const setupInfiniteScroll = () => {
    if (!sentinel || !canAjax) return;
    if (io) io.disconnect();

    io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry || !entry.isIntersecting) return;
        const current = getCurrentPage();
        const max = getMaxPages();
        if (isLoading) return;
        if (current >= max) return;

        const params = new URLSearchParams(window.location.search);
        params.delete("paged");
        doFetch({ paged: current + 1, params, mode: "append" });
      },
      { root: null, rootMargin: "800px 0px 800px 0px", threshold: 0.01 }
    );
    io.observe(sentinel);
  };
  setupInfiniteScroll();
  syncInfiniteVisibility();

  // Back/forward should reflect URL without reload.
  window.addEventListener("popstate", (e) => {
    if (!canAjax) return;
    fetchFromLocation({ replaceHistory: false });
  });
})();

